import { BaseEntity } from '../../base-entity';
import { LecturerRateDisplayType } from '../price-rate/lecturer-rate-display-type';

export enum WorkingHoursRefType {
  Lecture = 'lecture',
}

export enum WorkingHoursStatus {
  PendingForApproval = 'pendingForApproval',
  Approved = 'approved',
  Suspended = 'suspended',
  Reject = 'reject',
}

export interface WorkingHoursEntity2 extends BaseEntity {
  id: number;
  userId: number;
  branchId: number;
  activityTypeId: number;
  activityTypeName: string;
  branchLecturersRates: number;
  branchLecturersRatesId: number;
  startAt: Date;
  endAt: Date;
  versionNumber: number;
  parentRecordId: number;
  isManual: boolean;
  entityType: WorkingHoursRefType | null;
  entityRefId: number | null;
  status: WorkingHoursStatus;
  notes?: string;
  breakMinutes: number;

  parentId: number | null;
  isActive: boolean;

  displayType: LecturerRateDisplayType;
  branchName: string;
  courseId?: number | null;
  additionalCourseName?: string | null;
  courseName?: string | null;
  programId?: number | null;
  additionalProgramName?: string | null;
  programName?: string | null;
}

export interface WorkingHoursResponse extends WorkingHoursEntity2 {
  history: WorkingHoursEntity2[];
}
